/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ChangePasswordAliases {
  CHANGE_LAYOUT = 'change-layout',
  CONFIRM_PASSWORD_FIELD = 'confirm-password-field',
  CONFIRM_PASSWORD_INPUT = 'confirm-password-input',
  CONFIRM_PASSWORD_VALIDATION_TEXT = 'confirm-password-validation-text',
  FOM_LAYOUT = 'fom-layout',
  NEW_PASSWORD_FIELD = 'new-password-field',
  NEW_PASSWORD_INPUT = 'new-password-input',
  NEW_PASSWORD_VALIDATION_TEXT = 'new-password-validation-text',
  OLD_PASSWORD_FIELD = 'old-password-field',
  OLD_PASSWORD_INPUT = 'old-password-input',
  OLD_PASSWORD_VALIDATION_TEXT = 'old-password-validation-text',
  PANEL_FORM = 'panel-form',
  PASSWORD_SUBMIT_BUTTON = 'password-submit-button',
  PASSWORD_SUBMIT_PANEL = 'password-submit-panel',
  RESET_FORM = 'reset-form',
  ROOT_MODAL = 'root-modal',
}
export { ChangePasswordAliases };
